import { useCallback } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import { shipToLocationsAtom, selectedShipToAtom } from '../atoms/shipToLocationsAtom';
import { fetchShipToLocations } from '../services/api';

export const useShipToLocationsState = () => useAtomValue(shipToLocationsAtom);

export const useSelectedShipTo = () => useAtomValue(selectedShipToAtom);

export const useShipToLocationsActions = () => {
  const setShipToLocations = useSetAtom(shipToLocationsAtom);
  const setSelectedShipTo = useSetAtom(selectedShipToAtom);

  const getShipToLocations = useCallback(async () => {
    try {
      const response = await fetchShipToLocations();
      setShipToLocations(response);

      if (response.locations?.length === 1) {
        setSelectedShipTo(response.locations[0].shipTo);
      }
    } catch (error) {
      setShipToLocations(null);
      throw error;
    }
  }, [setShipToLocations, setSelectedShipTo]);

  const selectShipTo = useCallback(
    (shipTo: string | null) => {
      setSelectedShipTo(shipTo);
    },
    [setSelectedShipTo]
  );

  return {
    getShipToLocations,
    selectShipTo,
  };
};
